
import { LockDec, ValidateDec } from '@/decorators';
import { Component, Vue, Watch } from 'vue-facing-decorator'
import { Action, Getter, Mutation, State } from 'vuex-facing-decorator';
import QRCode from "qrcode";

@Component({})
export default class extends Vue {
  uploadLoading = false;

  /** 已提交的认证记录，null 表示未认证 */
  remoteInfo: any = null;

  /** 待支付：task_status=15 等待支付，apply_status=1 待支付 */
  get needPay() {
    let info = this.remoteInfo;
    if (!info) return false;
    return String(info.taskStatus) == '15' || String(info.applyStatus) == '1';
  }

  /** 微信认证的扫码地址（支付/授权），由 authUrl 本地生成 */
  authQrcode = '';

  get authName() {
    return this.formData.auth_data.account_name;
  }

  /** 审核中不可修改 */
  get readOnly() {
    return !!this.remoteInfo && this.remoteInfo.type == 1 && this.remoteInfo.auditType == 0;
  }

  /** 等待腾讯审核：task_status=12 创建认证审核单成功 */
  get waitingTencentAudit() {
    return String(this.remoteInfo?.taskStatus) == '12';
  }

  /** 审核派单信息：provider 审核公司, contact 联系方式, dispatch_time 派单时间 */
  get dispatch() {
    let raw = this.remoteInfo?.dispatchInfo;
    if (!raw) return null;
    if (typeof raw == 'object') return raw;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  get dispatchTime() {
    let time = this.dispatch?.dispatch_time;
    if (!time) return '';
    let str = String(time);
    /** 微信推送的是时间戳，兼容秒/毫秒，其余原样展示 */
    if (/^\d{13}$/.test(str)) return this.$format(Number(str));
    if (/^\d{10}$/.test(str)) return this.$format(Number(str) * 1000);
    return str;
  }

  get auditStatus() {
    let info = this.remoteInfo;
    if (!info) {
      return { type: 'none', title: '未认证', desc: '请填写以下信息并提交认证申请' };
    }
    if (this.needPay) {
      return { type: 'pay', title: '待支付', desc: '认证申请已提交，请使用微信扫码完成认证费用支付' };
    }
    /** 终态优先，避免被残留的 taskStatus 盖掉 */
    if (info.auditType == 1) {
      return { type: 'success', title: '认证成功', desc: '如需重新认证，可修改信息后再次提交' };
    }
    if (info.auditType == 2 || info.type == 2) {
      return { type: 'fail', title: '审核失败', desc: '本次认证未通过，可修改信息后重新提交' };
    }
    if (this.waitingTencentAudit) {
      return { type: 'pending', title: '等待腾讯审核', desc: '认证审核单已创建并派单，审核期间无法修改信息' };
    }
    if (info.type == 1 && info.auditType == 0) {
      return { type: 'pending', title: '审核中', desc: '认证申请已提交，审核期间无法修改信息' };
    }
    return { type: 'fail', title: '提交失败', desc: '上次申请未能提交成功，请修改后重新提交' };
  }

  selectCustomerType(value: number) {
    if (this.readOnly) return this.$error('审核中无法修改');
    this.formData.auth_data.customer_type = value;
  }

  async created() {
    this.getDocData();
    this.getData();
  }

  async getData() {
    let { error, data } = await this.$post("/manager/wechat/auth/audit-view");
    if (error) return;
    this.remoteInfo = data || null;
    if (data && data.content && data.content.auth_data) {
      this.formData = Object.assign(this.formData, data.content);
    }
    this.loadAuthQrcode();
  }

  async loadAuthQrcode() {
    this.authQrcode = '';
    if (!this.needPay || !this.remoteInfo.authUrl) return;
    try {
      this.authQrcode = await QRCode.toDataURL(this.remoteInfo.authUrl, { width: 200, margin: 1 });
    } catch (e) {
      this.authQrcode = '';
    }
  }

  async getDocData() {
    let { error, data } = await this.$get("/manager/wechat/auth/get-doc-list");
    if (error) return;
    data.list.map((item) => {
      this.showData[item.mediaId] = item.path;
    })
  }

  showData: Record<string, string> = {}
  @Watch("formData.auth_data.account_name")
  accountChange() {
    this.nameResult = null;
  }

  customerList = [
    { name: '企业', value: 1, desc: '适合有限公司等法人组织' },
    { name: '个体户', value: 12, desc: '适合个体工商户' }
  ]

  invoiceList = [{ name: '不开发票', value: 1 }, { name: '电子发票', value: 2 }]

  get postData() {
    return this.formData
  }

  submitLoading = false;

  nameResult = null;

  async checkName() {
    if (this.readOnly) return;
    let { error, data, message } = await this.$post(
      "/manager/open-platform/check-wechat-name",
      { name: this.formData.auth_data.account_name }
    );
    if (error) {
      this.nameResult = { type: 'error', message }
      return;
    }
    this.nameResult = { type: 'success', data }
  }

  @LockDec("submitLoading")
  @ValidateDec("form")
  async submit() {
    if (this.readOnly) return this.$error('审核中无法修改');
    await this.$postNotify("/manager/wechat/auth/submit-audit", this.postData);
    this.getData();
  }

  @LockDec("uploadLoading")
  async uploadFiles(fieldKey: string) {
    if (this.readOnly) return;
    let files = await this.$chooseFile();
    let fd = new FormData()
    fd.append('file', files[0])
    let { error, data, message } = await this.$upload("/manager/wechat/auth/upload-media", fd);
    if (error) {
      return this.$error(message);
    }
    let formdata = this.formData;
    let arr = fieldKey.split('.');
    arr.map((key, index) => {
      if (index == arr.length - 1) {
        formdata[key] = data.mediaId
        console.log(data)
      } else {
        formdata = formdata[key]
      }
    })
    this.showData[data.mediaId] = data.path;
  }

  @State((state) => state.store.store)
  store:any;


  formData = {
    auth_data: {
      customer_type: 1,
      contact_info: {
        name: '',
        email: ''
      },
      invoice_info: {
        invoice_type: 2,
        electronic: {
          id: '',
          desc: ''
        }
      },
      qualification: '',
      account_name: '',
      account_name_type: 1
    },

  }
}
